import Vue from 'vue'
import Vuex from 'vuex'
import {
  userMoney,
} from "@/services/api/user";
import router from '@/router'
import ConstConfig from "@/config/ConstConfig";
import { getGold } from "@/handle/RefreshBalance";
import { autoRegistration } from "@/handle/LoginHandle";
// import route from '@/route'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    lang: 'EN',
    loginShow: false,  // 登录弹窗显示
    loginType: 1,  // 登录弹窗类型
    loginInfo: {
      // user: 'hhhxaaa'
    }, // 登录用户信息
    loginCallBack: null,  // 登录回调
    payModalVisible: false,  // 充值弹窗
    token: "",  //玩家token
    isLogin: 0, //玩家是否登录 1:是 0:否
    currency: "MXN",//货币单位
    gameUrl: "",//全局内嵌游戏地址 localStorage.getItem(ConstConfig.LOCAL_CONST.GAME_URL)
    localeLanguage: "", //当前语言环境
    gold: 0, //账户余额
    code: "", //邀请码
    nickName: "", //玩家昵称
    headUrl: "", //玩家头像
    userId: "", //用户id
    versionType: 0,//用户所属版本
    versionTypeMode: 0,//用户所属版本展示模式,默认0:77模式,1:88模式
    userType:"", //获取哪一个客服链接
    VIP:"", //VIP等级
    WithdrawPopups: 0,//111提现成功弹窗
    payModalAmonut: 0,//提现--固定充值金额激活
    myLevel: 0,//VIP等级
    joinGameTipsType: 0,//点击三方游戏提示类型
    spinning: false, //全局加载效果
    // 4:弹新用户转盘,5:弹分享
    visible: 0, //0：关闭 1：VIP>=2&&超过3000提示可见 2:VIP0 && (游戏余额-平台余额)/100>1 3:新用户为登录提示 4新用户登录提示 , 6 邀请奖励领取提示
    Time: null, //定时器 用户点击浏览器返回清空
    gameType: "", //玩家点击哪个类型的游戏

    //successTips组件相关信息
    tipsVisible:false,//是否显示提示
    tipsType: 0, //提示类型 // 0:不做操作,1:跳转充值,2:跳转提现,3:跳转游戏,4:交税
    tipsMsg: '', //提示信息
    tipsBtn: '', //提示按钮
    tipsMethod: null,//按钮关闭方法
    tipsOkMethod: null,//按钮确定方法
    taxMoney: 0,//提现税费
    vipStep: 0,//提现步骤
    stepConfig: null,//步骤配置
    gameNum: 0,//游戏局数
    //chargeTips组件相关信息
    chargeTipsVisible:false,//是否显示提示

    showPixType: false,//是否显示pix
    payType: 8,//支付类型

    withdrawSelectKey:0,//提现标签选择,0:提现,1:历史记录

    /**书签提示弹框 */
    isShowBookmarkDialog: false,
    showNewCharge: false,//是否弹首充
    /**是否支持书签弹窗 */
    deferredPrompt: null,
    // 初始化随机金币
    initGold: 0,
    onlineNumMap:null,
    //B版第六步发起订单后,10秒是否提示弹框 ,存储创建时间戳
    isShowStep6Tips: 0,
    // 是否显示C版进度提示
    progressTipsVisible: false,
    tipsProgressMsg: '', //进度条提示信息
    notGame: 0, //是否禁止访问游戏 默认0:允许访问游戏 1:禁止访问游戏
    orderId: "", //是否禁止访问游戏 默认0:允许访问游戏 1:禁止访问游戏
  },
  mutations: {
    // 控制登录弹窗显示
    handleLoginVisible(state, value) {
      state.loginShow = value
    },
    // 设置用户信息
    setUserInfo(state, value) {
      state.loginInfo = value
    },
    // 设置登录回调
    setLoginCallBack(state, value) {
      state.loginCallBack = value
    },
    // 设置充值弹窗显示
    setPayModalVisible(state, value) {
      state.payModalVisible = value
      if(value == true){
        let nowRoute = router.currentRoute.path;
        let query = router.currentRoute.query;
        router.push({
          path: nowRoute,
          query: {
            "model": "Paymodel",
            ...query
          },
        });
      }
    },
    // 刷新账户余额
    getRefreshBalance(state, value) {
      if(state.isLogin == 1){
          getGold();
      }
    }
  },
  actions: {
    // 验证登录
    handleCheckLogin({ commit, state }) {
      /**未获取到获取设备id进行一键登录*/
      let deviceId = localStorage.getItem(ConstConfig.LOCAL_CONST.DEVICE_ID);
      if(!deviceId){
        autoRegistration()
      }
      // 未获取到token值视为未登录状态
      else if (!state.token) {
        commit('handleLoginVisible', true)
      } else {
        state.loginCallBack && state.loginCallBack()
      }
    }
  }
})

export default store
